import { useRouter } from 'next/router';
import React from 'react';
import WidgetFollow from 'src/components/widgets/widget-follow';
import { APP_IMG } from 'src/constants';
import { DATALAYER_TYPE, sendDataLayerGlobal } from 'src/utils/datalayer/send-datalayer';
import { convertDatasets } from 'src/utils/datasets';
import styled from 'styled-components';
import CardV from 'src/components/cards/card-v';

function Vejpongosot120years({ data, dataset }: any) {
  const router = useRouter();
  const datalist = dataset?.data;
  return (
    <FooterWrapper background={convertDatasets(data, 'background-image', true)}>
      <div id='vejpongosot' className='container'>
        {datalist && (
          <>
            {datalist.map((item: any, index: any) => (
              <div key={index}>
                <CardV
                  data={item}
                  showByline={true}
                  showTitle={true}
                  showBlurb={true}
                  showTime={true}
                  showCountview={true}
                  external={false}
                  className=''
                  //! DATALAYER
                  eventDataLayer={{
                    type: DATALAYER_TYPE.TRACK_INDEX,
                    router: router?.pathname,
                    section: 'section-6',
                    data: {
                      title: item?.title,
                      heading: 'game-changer-Page',
                      index: 1
                    }
                  }}
                />
              </div>
            ))}
          </>
        )}
      </div>
      <div className='container content'>
        <div className='info-wrapper'>
          <a
            className='register-button'
            href={convertDatasets(data, 'link-vejpongosot', true)}
            // ! DATALAYER
            onClick={() => {
              sendDataLayerGlobal({
                type: DATALAYER_TYPE.TRACK_POSITION,
                router: router.pathname,
                section: 'section-footer',
                position: 'on:vejpongosot120years-page',
                data: {
                  heading: convertDatasets(data, 'logo', true)
                }
              });
            }}
          >
            <img className='svg-logo' src={convertDatasets(data, 'logo', true)} />
          </a>
          <img className='title-image' src={convertDatasets(data, 'heading-text', true)} />
        </div>
      </div>
    </FooterWrapper>
  );
}
interface StyledProps {
  background: string;
}
const FooterWrapper = styled.div<StyledProps>`
  position: relative;
  width: 100%;
  padding: 30px 0;
  background-image: url(${props => props?.background});
  background-size: cover;
  background-position: bottom center;

  @media (max-width: 767px) {
    // background-image: none;
    // background-color: #eb3243;
  }

  .content {
    display: flex;
    justify-content: space-between;
    align-items: center;

    @media (max-width: 767px) {
      flex-direction: column;
      gap: 25px;
    }

    .left {
      position: relative;
      width: 50%;
      display: flex;
      gap: 20px;

      @media (max-width: 992px) {
        gap: 10px;
      }

      @media (max-width: 767px) {
        width: 100%;
        justify-content: space-around;
        align-items: center;
      }

      @media (max-width: 475px) {
        flex-direction: column;
      }

      .image-wrapper {
        position: relative;
        background: #fff;
        padding: 10px;
        border-radius: 15px;
        width: 40%;

        @media (max-width: 767px) {
          width: 45%;
        }

        @media (max-width: 475px) {
          width: 70%;
        }

        .custom-image {
          width: 50%;
        }
      }
    }

    .info-wrapper {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      width: 100%;

      .title-image {
        width: 100%;

        @media (max-width: 992px) {
          width: 65%;
        }

        @media (max-width: 475px) {
          width: 75%;
        }
      }

      .svg-logo {
        width: 100%;

        @media (max-width: 992px) {
          width: 100%;
        }

        @media (max-width: 475px) {
          width: 65%;
        }
      }

      .register-button {
        display: flex;
        width: 35%;
        justify-content: center;
        transition: all 0.3s ease-in-out;
        cursor: pointer;

        &:hover {
          // background-color: #f8f9f8;
          // color: #b30e0e;
        }

        @media (max-width: 992px) {
          // font-size: 28px;
        }

        @media (max-width: 475px) {
          width: 70%;
          // font-size: 22px;
        }
      }
    }

    .right {
      width: fit-content;
      position: relative;
      display: flex;
      justify-content: space-around;
      align-items: center;
      width: 50%;

      @media (max-width: 767px) {
        width: 100%;
      }

      @media (max-width: 475px) {
        flex-direction: column;
      }

      .text {
        font-weight: 400;
        color: white;
        font-size: 14px;

        @media (max-width: 767px) {
          font-size: 12px;
        }
      }

      .image {
        width: 40%;
      }
    }
  }

  #vejpongosot {
    .card-v {
      background: #ffffff;
      margin-bottom: 7rem;

      @media (max-width: 475px) {
        margin-bottom: 3rem;
      }
    }

    .card {
      margin-top: 0;
      padding: 20px;
    }

    .card.--content {
      h3 {
        font-size: 28px;
        font-weight: bold;
        color: #333;

        @media (max-width: 475px) {
          font-size: 20px;
        }
      }

      .text-excerpt-2 {
        font-size: 20px;
        line-height: 1.6;
        color: #555;

        @media (max-width: 475px) {
          font-size: 16px;
        }
      }
    }

    .meta-contents {
      .meta {
        .date-time,
        .pageviews {
          font-size: 16px;
          color: #777;
          line-height: 1.4;

          @media (max-width: 475px) {
            font-size: 14px;
          }
        }
      }
    }
  }
`;

export default Vejpongosot120years;
